'use client';

import { Box, FormHelperText, FormLabel } from '@mui/material';
import { INTAKE_PLACEHOLDERS, intakeFieldLabelSx } from '../intake-copy';
import { IntakeCountryPicker } from './IntakeCountryPicker';

type Props = {
  value: string;
  detectedIso: string | null;
  error?: string;
  onChange: (iso2: string) => void;
  onBlur: () => void;
};

const LABEL_ID = 'intake-country-label';
const TRIGGER_ID = 'intake-country';
const LIST_ID = 'intake-country-list';
const ERROR_ID = 'intake-country-help';

export function IntakeCountryField({
  value,
  detectedIso,
  error,
  onChange,
  onBlur,
}: Props) {
  return (
    <Box>
      <FormLabel
        id={LABEL_ID}
        sx={intakeFieldLabelSx}
        htmlFor={TRIGGER_ID}
        error={Boolean(error)}
      >
        Country of residence
      </FormLabel>
      <IntakeCountryPicker
        mode="name"
        id={TRIGGER_ID}
        listId={LIST_ID}
        value={value}
        detectedIso={detectedIso}
        placeholder={INTAKE_PLACEHOLDERS.country}
        searchPlaceholder="Search country"
        searchAriaLabel="Search country"
        listAriaLabel="Country of residence"
        ariaLabelledBy={LABEL_ID}
        required
        fullWidth
        error={error}
        errorId={ERROR_ID}
        onChange={onChange}
        onBlur={onBlur}
      />
      {error && (
        <FormHelperText id={ERROR_ID} error sx={{ mx: 0, mt: 0.75 }}>
          {error}
        </FormHelperText>
      )}
    </Box>
  );
}
